<template>
  <div class="download">
    <banner :img="imgurl" title="党建工作" />






  <div class="djtitle" > 
        <div class="titlecontext" >
            <div class="titleTop">{{formData.Title}}</div>
            <div class="titleTime">{{formData.CreateTime  |dateFormat}} &nbsp; &nbsp;&nbsp;&nbsp;来源：永贵机修</div>
          <hr/>
            <div class="titleText">{{formData.Content}}</div>
     </div>
  </div>

  <!-- <div class="djfooter">
   
    
  </div> -->




  </div>
</template>

<script>
import Banner from "../components/Banner";
export default {
  components: {
    Banner,
  },
  data() {
    return {
      textid:"",  
      imgurl: require("../assets/img/list_bg.png"),
          formData: {
        Id: 0,
        Img: "",
        Title: "",
        Content: "",
        Del: "",
        CreateTime: new Date()
      },
         serviceList: [
                {
                    id: 'section-1',
                    title: '鹤煤中泰矿业 携手奋进促生产',
                    time: '2022-03-11',
                    text: "人间最美三月天，春花烂漫展新颜。3月8日一早，鹤煤公司中泰矿业工会组织女工在井口开展了“携手保平安聚力促生产”协管活动，用真情唤起职工的安全意识，共同构筑安全生产防线，用实际行动庆祝自己的节日。　　“扣子掉了，能帮我订个扣子吗？”“袖口烂了，麻烦您帮我缝一下。”……刚上井的工人师傅们围在井口缝补站，你一句我一句地询问。“行！”“来，我帮你补”“干活别忘了安全”女工协管员们耐心、热心地回复着每一位工人师傅，及时帮助他们缝补好衣物。　　每周两次为一线职工缝补工作服、钉纽扣已是女工协管会协管员发挥女性特长、筑牢亲情防线、服务安全生产的一项基础性、常态化工作，通过活动的持续开展，让职工们深切感受到“娘家人”的温暖，进一步增强了凝聚力。　　随后，协管员们又来到各自包保的单位为节日期间奋战在岗位上的女工送上了慰问品，祝她们节日快乐，并感谢她们为企业作出的贡献。",
                },{
                    id: 'section-2',
                    title: '新疆龟兹矿业 “两癌”筛查暖人心',
                    time: '2022-03-11',
                    text: "3月5日~6日，新疆公司龟兹矿业工会积极对接库车市妇幼保健院，为该矿60余名女职工开展“两癌”免费筛查，为女职工撑起健康“保护伞”。“两癌”筛查是指宫颈癌筛查和乳腺癌筛查，通过B超检查、宫颈脱落细胞检查等先进检查手段，准确地将乳腺癌和宫颈癌检查出来，使适龄妇女对自身健康有一个全面准确的认知，切实做到早预防、早发现、早诊断、早治疗。",
              
                },{
                    id: 'section-3',
                    title: '永煤铁运处 促青工快速成才',
                    time: '2022-02-16',
                    text: "该处在月度培训中设立班组、站段、处三级课堂。并在处、站段课堂上由特长职工进行知识讲解。该处在新入职大学生职工中选拔人员进行内燃机车副司机、司机技能培养。做好人才储备。"
                },{
                    id: 'section-4',
                    title: '焦煤赵固一矿 让雷锋精神在岗位上闪光',
                    time: '2021-09-30',
                    text: "该矿团委组织青年志愿者开展了。青年志愿者奉献活动。组织青年志愿者义务打扫矿区环境、清除卫生死角。该矿团委把开展青年志愿者学雷锋活动与创建。"
                }
            ]
    };
  },
   methods: {
    handleSelect(key) {
      this.isShow = this.defaultActive != key;
      window.console.log(this.isShow);
    },
      loadData() {
      this.loading = true;
      this.$http
        .get(`News/${this.textid}`)
        .then(response => {
           window.console.log(response.data.result);
          if(response.status==200){
            if(response.data.result.length!=0){
       
              this.formData.Title =response.data.result.title;
              this.formData.CreateTime =response.data.result.createTime;
              this.formData.Content =response.data.result.content;
              this.loading = false;
            }
          }
         
        })
        .catch(e => {
          this.$message({
            message: "网络或程序异常！" + e,
            type: "error"
          });
        });
    },

  },
  mounted() {
      this.textid = this.$route.params.id;
      this.loadData();
  }
};
</script>

<style lang="scss" scoped>
.radionstyle{

  justify-content: space-between;
  align-content: center;
  width: 1240px;
  margin: 0 auto;
}
.el-radionstyle-demo {
  background-color: rgb(163, 172, 166);
  opacity: 0.4;
}



.djtitle{

  align-content: center;
  height: auto;
   width: 1240px;

  justify-content: stretch;
   margin: 0 auto;
   display: flex;
   margin-bottom: 5px;

   .titlecontext{
      
       
  height: auto;
     width: 1240px;
 
   }
   .titleTop{
       margin-top: 5px;
    font-size: 26px;
    text-align: center;
    color: #000;
    line-height: 35px;
    
   }
   .titleTime{
       text-align: center;
    display: block;
    font-size: 14px;
   
    margin-top: 8px;
    line-height: 24px;
   }
   .titleText{
       box-sizing: border-box;
           padding: 20px 20px;
       margin-top: 14px;
    
    line-height: 24px;
    text-indent: 2em;
   }
}





.djfooter{
   align-content: center;
   height: 650px;
   width: 99.9%;
   
   justify-content: stretch;
   margin: 0 auto;
 
   background-color: #eee;
   .footertitle{
       padding-top: 10px;
text-align: center;
margin-right: 1000px;
   }
   .footerimg{
     margin-top: 40px;
     text-align: center;
padding-right: 0px;
   }
}

</style>
